import { render, staticRenderFns } from "./DistrictDetails.vue?vue&type=template&id=00431ba2"
import script from "./DistrictDetails.vue?vue&type=script&lang=js"
export * from "./DistrictDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports